import React, { Component } from 'react'
import {Button} from 'react-bootstrap'
import heading from './assets/meetra_long.png'
import Footer from './Footer';

export class Admin extends Component {
    render() {
        return (
            <div className="main-container">
                <center><img src={heading} width="70%"></img></center>
                <hr/>
                <div className="head">
                <h1>Admin Dashboard</h1>
                <Button className="btn1-signout" type="submit" onClick={() => this.props.history.push({pathname:'/NewTraining'})}>New training</Button></div>
                <hr/>
                
                <Footer/>
            </div>
        )
    }
}

export default Admin
